/**
 * Best Time to Visit Section Component
 * Displays best time to visit information
 * Uses custom header with overview icon (matching overview section)
 */

import React, { useState } from 'react';
import { motion } from 'framer-motion';
import {
  typographyColors,
  spacing,
  typography,
  fontPrimary,
} from '@/design-system/utils';
import { ShowMoreTextButton } from '@/components/ui/show-more-text-button';
import { useTextOverflow } from '@/hooks/useTextOverflow';
import { SectionHeaderWithIcon } from '../overview/SectionHeaderWithIcon';

export interface BestTimeToVisitSectionProps {
  bestTimeToVisit: string;
  placeName?: string;
}

export const BestTimeToVisitSection: React.FC<BestTimeToVisitSectionProps> = ({
  bestTimeToVisit,
  placeName,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const { textRef, exceedsLines } = useTextOverflow<HTMLParagraphElement>(
    3,
    bestTimeToVisit
  );

  return (
    <div
      style={{
        width: '100%',
      }}
    >
      {/* Custom header with overview icon (matching overview section) */}
      <div
        style={{
          marginBottom: spacing[3],
        }}
      >
        <SectionHeaderWithIcon
          icon='/assets/images/icons/overview.svg'
          iconAlt='Overview icon'
          title={`Best Time to Visit${placeName ? ` ${placeName}` : ''}`}
        />
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: spacing[1],
        }}
      >
        <motion.p
          ref={textRef}
          animate={{
            WebkitLineClamp: isExpanded ? 'none' : 3,
          }}
          transition={{
            duration: 0.3,
            ease: [0.4, 0, 0.2, 1],
          }}
          style={{
            fontFamily: fontPrimary,
            fontSize: typography.size.base,
            fontWeight: typography.weight.regular,
            color: typographyColors.text,
            lineHeight: typography.lineHeight.relaxed,
            margin: 0,
            display: '-webkit-box',
            WebkitLineClamp: isExpanded ? 'none' : 3,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
          }}
        >
          {bestTimeToVisit}
        </motion.p>
        {exceedsLines && (
          <ShowMoreTextButton
            isExpanded={isExpanded}
            onClick={() => setIsExpanded(!isExpanded)}
          />
        )}
      </div>
    </div>
  );
};
